;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _from = require("babel-runtime/core-js/array/from");

var _from2 = _interopRequireDefault(_from);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _HostedCheckoutUserDetails = require("./HostedCheckoutUserDetails.vue");

var _HostedCheckoutUserDetails2 = _interopRequireDefault(_HostedCheckoutUserDetails);

var _HostedCheckoutSdk = require("./HostedCheckoutSdk.vue");

var _HostedCheckoutSdk2 = _interopRequireDefault(_HostedCheckoutSdk);

var _MpgsHostedCheckoutSdk = require("./MpgsHostedCheckoutSdk.vue");

var _MpgsHostedCheckoutSdk2 = _interopRequireDefault(_MpgsHostedCheckoutSdk);

var _HostedCheckoutProcessing = require("./HostedCheckoutProcessing.vue");

var _HostedCheckoutProcessing2 = _interopRequireDefault(_HostedCheckoutProcessing);

var _VerifyTransaction = require("../payment_categories/VerifyTransaction.vue");

var _VerifyTransaction2 = _interopRequireDefault(_VerifyTransaction);

var _eventBus = require("../../iframeV3/eventBus.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "HostedCheckoutCard",
  components: {
    HostedCheckoutUserDetails: _HostedCheckoutUserDetails2.default,
    HostedCheckoutSdk: _HostedCheckoutSdk2.default,
    MpgsHostedCheckoutSdk: _MpgsHostedCheckoutSdk2.default,
    HostedCheckoutProcessing: _HostedCheckoutProcessing2.default,
    VerifyTransaction: _VerifyTransaction2.default
  },
  props: {
    gateway: {
      type: Object,
      required: true
    },
    invoice: {
      type: Object,
      required: true
    },
    amount_due: {
      type: [Number, String],
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    invoice_no: {
      type: String,
      required: true
    },
    bill_ref: {
      type: String,
      default: ""
    },
    base_url: {
      type: String,
      required: true
    },
    callback_url: {
      type: String,
      required: true
    },
    status_api_url: {
      type: String,
      default: ""
    },
    csrf_token: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      step: "",
      initializing: false,
      processor: "cybersource",

      captureContext: "",
      clientLibrary: "",
      clientLibraryIntegrity: "",
      transientToken: "",
      completedCaptureContext: "",

      sessionId: "",
      sessionVersion: "",
      successIndicator: "",
      checkoutJsUrl: "",
      mpgsOrderId: "",

      processingState: "processing",
      processingMessage: "",
      retryAllowed: true,
      errorMessage: "",
      userDetails: {},
      parentDomain: document.referrer,
      iframeDomain: window.location.origin
    };
  },
  mounted: function mounted() {

    this.handleDetailsSubmitted({});
    _eventBus.eventBus.$emit("gateway-fees-updated", this.gateway.configs.card_charges);
  },

  computed: {
    captureContextUrl: function captureContextUrl() {
      var path = this.gateway.configs && this.gateway.configs.unified_checkout_capture_context_url || "/api/unified-checkout/capture-context";
      return this.base_url + path;
    },
    confirmUrl: function confirmUrl() {
      var path = this.gateway.configs && this.gateway.configs.unified_checkout_confirm_url || "/api/unified-checkout/confirm";
      return this.base_url + path;
    },
    processorLabel: function processorLabel() {
      if (this.processor === "mastercard") return "Secured by Mastercard";
      return "Secured by CyberSource";
    },
    amountToCharge: function amountToCharge() {
      var amount = parseFloat(this.gateway.configs.card_charges) + parseFloat(this.invoice.amount_expected);

      return Math.ceil(amount * 100) / 100;
    },
    targetOrigins: function targetOrigins() {
      var origins = [this.iframeDomain];
      var ancestors = window.location.ancestorOrigins;
      if (ancestors && ancestors.length) {
        origins.push.apply(origins, (0, _toConsumableArray3.default)((0, _from2.default)(ancestors)));
      } else if (this.parentDomain) {
        console.warn("[UC] ancestorOrigins unavailable, falling back to referrer (direct parent only)");
        try {
          origins.push(new URL(this.parentDomain).origin);
        } catch (e) {
          console.error("[UC] could not parse referrer:", this.parentDomain, e);
        }
      }
      var result = [].concat((0, _toConsumableArray3.default)(new _set2.default(origins)));
      console.log("[UC] target_origins sent to capture context:", result);
      return result;
    }
  },
  methods: {
    authHeaders: function authHeaders() {
      return {
        headers: {
          "x-csrf-token": this.csrf_token,
          "Content-Type": "application/json"
        }
      };
    },
    handleDetailsSubmitted: async function handleDetailsSubmitted(details) {
      this.userDetails = details;
      this.errorMessage = "";
      this.initializing = true;
      this.step = "initializing_iframe";

      var payload = {
        gid: this.gateway.id,
        ref_no: this.invoice_no,
        tracking_no: this.invoice_no + "-" + Date.now(),
        amount: this.amountToCharge,
        currency: this.currency,
        target_origins: this.targetOrigins
      };

      try {
        var response = await Vue.axios.post(this.captureContextUrl, payload, this.authHeaders());
        var data = response.data;

        if (data && data.success) {
          this.processor = data.processor || "cybersource";

          if (this.processor === "mastercard") {
            this.sessionId = data.session_id;
            this.sessionVersion = data.session_version;
            this.successIndicator = data.success_indicator;
            this.checkoutJsUrl = data.checkout_js_url;
            this.mpgsOrderId = data.order_id || this.invoice_no;

            if (!this.sessionId || !this.checkoutJsUrl) {
              this.errorMessage = "Unable to start the secure checkout. Please try again.";
              return;
            }
          } else {
            this.captureContext = data.jwt;
            this.clientLibrary = data.client_library_url;
            this.clientLibraryIntegrity = data.client_library_integrity;

            if (!this.captureContext || !this.clientLibrary) {
              this.errorMessage = "Unable to start the secure checkout. Please try again.";
              return;
            }
          }

          this.step = "sdk";
        } else {
          this.errorMessage = data && data.message || "Unable to start the secure checkout. Please try again.";
        }
      } catch (err) {
        this.errorMessage = "We couldn't start the secure checkout. Please try again in a moment.";
      }
    },
    handlePaymentComplete: async function handlePaymentComplete(payload) {
      this.transientToken = payload.transientToken;
      this.completedCaptureContext = payload.captureContext;

      await this.submitConfirm({
        gid: this.gateway.id,
        ref_no: this.invoice_no,
        result_jwt: payload.result
      });
    },
    handleMpgsComplete: async function handleMpgsComplete(payload) {
      await this.submitConfirm({
        gid: this.gateway.id,
        ref_no: this.invoice_no,
        session_id: payload.sessionId,
        order_id: payload.orderId,
        result_indicator: payload.resultIndicator,
        session_version: payload.sessionVersion
      });
    },
    handlePaymentCancelled: function handlePaymentCancelled() {
      this.processingMessage = "";
      this.errorMessage = "";
    },
    submitConfirm: async function submitConfirm(body) {
      this.step = "processing";
      this.processingState = "processing";
      this.processingMessage = "";
      this.retryAllowed = true;

      try {
        var response = await Vue.axios.post(this.confirmUrl, body, this.authHeaders());
        this.applyConfirmResult(response && response.data);
      } catch (err) {
        var data = err && err.response && err.response.data || null;

        if (data && (typeof data === "undefined" ? "undefined" : (0, _typeof3.default)(data)) === "object") {
          this.applyConfirmResult(data);
        } else {
          this.processingState = "manual";
          this.processingMessage = "We received your payment but couldn't confirm it just yet. If you were charged, please contact support.";
          this.retryAllowed = false;
        }
      }
    },
    applyConfirmResult: function applyConfirmResult(data) {
      if (!data || (typeof data === "undefined" ? "undefined" : (0, _typeof3.default)(data)) !== "object") {
        this.processingState = "manual";
        this.processingMessage = "";
        this.retryAllowed = false;
        return;
      }

      this.processingMessage = data.message || "";
      this.retryAllowed = data.retry_allowed !== false;

      switch (data.outcome) {
        case "authorized":
          this.processingState = "success";
          this.retryAllowed = false;
          break;

        case "pending":
        case "review":
          this.processingState = "manual";
          this.retryAllowed = false;
          break;

        case "declined":
        case "authentication_failed":
        case "cancelled":
          this.processingState = "declined";
          this.retryAllowed = data.retry_allowed !== false;
          break;

        case "invalid_request":
        case "failed":
        case "error":
          this.processingState = "error";
          break;

        default:
          if (data.success === true) {
            this.processingState = "success";
            this.retryAllowed = false;
          } else {
            this.processingState = "error";
          }
      }
    },
    handlePaymentError: function handlePaymentError() {
      this.step = "processing";
      this.processingState = "error";
      this.processingMessage = "The payment could not be completed. Please try again or use a different card.";
      this.retryAllowed = true;
    },
    handleTimeout: function handleTimeout() {
      this.step = "processing";
      this.processingState = "error";
      this.processingMessage = "The payment could not be completed. Please try again or use a different card.";
      this.retryAllowed = true;
    },
    resetFlow: function resetFlow() {
      this.step = "sdk";
      this.captureContext = "";
      this.clientLibrary = "";
      this.clientLibraryIntegrity = "";
      this.transientToken = "";
      this.completedCaptureContext = "";
      this.sessionId = "";
      this.sessionVersion = "";
      this.successIndicator = "";
      this.checkoutJsUrl = "";
      this.mpgsOrderId = "";
      this.processingState = "processing";
      this.processingMessage = "";
      this.retryAllowed = true;
      this.errorMessage = "";
      this.handleDetailsSubmitted({});
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col gap-4 h-full"},[_c('div',{staticClass:"flex items-center justify-between border-b border-gray-100 pb-3"},[_c('div',{staticClass:"flex items-center gap-2"},[_c('svg',{staticClass:"h-6 w-6 text-[#3c65f5]",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"}},[_c('rect',{attrs:{"x":"2","y":"6","width":"20","height":"12","rx":"2","ry":"2"}}),_vm._v(" "),_c('line',{attrs:{"x1":"2","y1":"10","x2":"22","y2":"10"}})]),_vm._v(" "),_c('h2',{staticClass:"text-base sm:text-lg font-semibold text-gray-800"},[_vm._v("Pay with Card")])])]),_vm._v(" "),(_vm.step === 'details')?_c('HostedCheckoutUserDetails',{attrs:{"invoice":_vm.invoice,"submitting":_vm.initializing},on:{"submitted":_vm.handleDetailsSubmitted}}):_vm._e(),_vm._v(" "),(_vm.step === 'initializing_iframe')?_c('VerifyTransaction'):_vm._e(),_vm._v(" "),(_vm.step === 'sdk')?_c('div',{staticClass:"bg-white rounded-lg p-4 sm:p-6 border border-gray-100"},[(_vm.processor === 'cybersource')?_c('HostedCheckoutSdk',{attrs:{"jwt":_vm.captureContext,"clientLibrary":_vm.clientLibrary,"clientLibraryIntegrity":_vm.clientLibraryIntegrity},on:{"payment-complete":_vm.handlePaymentComplete,"payment-error":_vm.handlePaymentError}}):(_vm.processor === 'mastercard')?_c('MpgsHostedCheckoutSdk',{attrs:{"session_id":_vm.sessionId,"checkout_js_url":_vm.checkoutJsUrl,"order_id":_vm.mpgsOrderId},on:{"payment-complete":_vm.handleMpgsComplete,"payment-cancelled":_vm.handlePaymentCancelled,"payment-error":_vm.handlePaymentError,"payment-timeout":_vm.handleTimeout}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.step === 'processing')?_c('div',{staticClass:"bg-white rounded-lg p-4 sm:p-6 border border-gray-100"},[_c('HostedCheckoutProcessing',{attrs:{"state":_vm.processingState,"callback_url":_vm.callback_url,"message":_vm.processingMessage,"retry_allowed":_vm.retryAllowed},on:{"retry":_vm.resetFlow}})],1):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('p',{staticClass:"text-red-500 text-sm"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-aa07592a", __vue__options__)
  } else {
    hotAPI.reload("data-v-aa07592a", __vue__options__)
  }
})()}